<template>
  <div>
    <h3 class="text-center">Доверенность №{{ document_number }}</h3>
    <div class="d-flex">
      <div class="mr-auto">г. Нур-Султан</div>
      <div>{{ date }}</div>
    </div>
    <p class="text-justify my-2" style="text-indent: 50px">
      {{ оrganizations.org_name }}, являющееся юридическим лицом по
      законодательству Республики Казахстан, юридический адрес:
      {{ оrganizations.company_address }}, БИН {{ оrganizations.org_code }} в
      лице Директора {{ оrganizations.company_ceo }}, действующего на основании
      Устава, уполномачивает:
    </p>
    <p class="text-justify my-2" style="text-indent: 50px">
      - ТОО «KAZ DIGICONTRACT» (Республика Казахстан, Г.НУР-СУЛТАН, РАЙОН ЕСИЛЬ,
      УЛИЦА ДІНМҰХАМЕД КОНАЕВ, 4, регистрационный номер БИН 140940022635), в
      лице директора Панова Алмаса Бахтыяровича, действующего на основании
      Устава, выполнять все необходимые действия по получению и обработке
      информации по лицевому счету на жд дороге, о дислокации, техническом
      состоянии и работе подвижного состава, находящегося в собственности,
      аренде, лизинге, в безвозмездном пользовании {{ оrganizations.org_name }},
      или принадлежащего ему и,или его клиентам на иных законных основаниях.
    </p>
    <p class="text-justify my-2" style="text-indent: 50px">
      Настоящая доверенность выдана для предъявления в администрации железных
      дорог, их обособленные подразделения, дочерние структуры, а также любые
      другие организации, связанные с эксплуатацией и ремонтом подвижного
      состава.
    </p>
    <p class="text-justify my-2" style="text-indent: 50px">
      Код собственника (арендатора) вагонов:
    </p>
    <p class="text-justify my-2" style="text-indent: 50px">
      Код грузополучателя/отправителя на КЗХ дороге:
    </p>
    <p class="text-justify my-2" style="text-indent: 50px">ОКПО:</p>
    <p class="text-justify my-2" style="text-indent: 50px">
      Код экспедитора на КЗХ дороге:
    </p>
    <p class="text-justify my-2" style="text-indent: 50px">Код плательщика:</p>
    <br />
    <p class="text-justify my-2" style="text-indent: 50px">
      Доверенность выдана на бессрочный период.
    </p>
    <div class="d-flex">
      <p class="mr-auto">
        <strong>Директор</strong> {{ оrganizations.org_name }}
      </p>
      <p>
        {{ оrganizations.company_ceo }}
      </p>
    </div>
    <canvas id="signature_canvas"></canvas>
  </div>
</template>
<script>
import moment from "moment";
var QRCode = require("qrcode");
export default {
  props: ["user_id"],
  data() {
    return {
      оrganizations: {},
      xml: "",
      ecp_storage: "",
      document_number: "-",
    };
  },
  mounted() {
    axios
      .get(window.base + "/document/getfirmceo?user_id=" + this.user_id)
      .then((response) => {
        this.оrganizations = response.data;
        axios.get(window.base + "/contract/pdfNumber").then((response) => {
          this.document_number = response.data;
          axios
            .get(
              window.base + "/document/getfirmceoxml?user_id=" + this.user_id,
            )
            .then((response) => {
              this.xml = response.data.replace(
                '<?xml version="1.0" encoding="utf-16"?>',
                "",
              );
              window.webSocket = new WebSocket("wss://127.0.0.1:13579/");
              window.callback = null;

              window.webSocket.onopen = (event) => {
                console.log("Connection opened");
                // window.getKeyInfo("PKCS12", (r)=>{
                //     console.log('info', r)
                // })
                window.signXml("PKCS12", "SIGNATURE", this.xml, (tmp) => {
                  // console.log(tmp)
                });
              };

              window.webSocket.onclose = function (event) {
                if (event.wasClean) {
                  console.log("connection has been closed");
                } else {
                  console.log("Connection error");
                  openDialog();
                }
                console.log("Code: " + event.code + " Reason: " + event.reason);
              };

              window.webSocket.onmessage = (event) => {
                var result = JSON.parse(event.data);
                console.log(result, event);
                if (result != null) {
                  var rw = {
                    code: result["code"],
                    message: result["message"],
                    responseObject: result["responseObject"],
                    getResult: function () {
                      return this.result;
                    },
                    getMessage: function () {
                      return this.message;
                    },
                    getResponseObject: function () {
                      return this.responseObject;
                    },
                    getCode: function () {
                      return this.code;
                    },
                  };
                  this.callback(rw);
                }
              };
            });
        });
      });
  },
  methods: {
    callback(r) {
      if (r.code == "200") {
        // console.log(r)
        var oParser = new DOMParser();
        var oDOM = oParser.parseFromString(
          r.getResponseObject(),
          "application/xml",
        );
        var value = oDOM.getElementsByTagName("ds:SignatureValue")[0].innerHTML;
        var canvas = QRCode.toCanvas(value, { width: 150, height: 150 });
        canvas.then((r) => {
          this.$root.$emit("print-pdf", r);
        });
      }
    },
  },
  computed: {
    date() {
      return moment().format("D.MM.Y");
    },
  },
};
</script>
